import React, { useEffect, useState } from 'react';
import Menu from '../Menu/Menu';
import { useNavigate, useParams } from 'react-router-dom';
import { Avatar, Box, Typography, Button, Dialog, DialogTitle, DialogContent, List, ListItemButton, ListItemAvatar, ListItemText } from '@mui/material';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { pickersLayoutClasses } from '@mui/x-date-pickers/PickersLayout';
import image from '../../assets/contentImage/beeDefense.png';
import api from '../../utils/axios.secure';

function Detailprescription() {
  const [detailUser, setDetailUser] = useState([]);
  const [contentList, setContentList] = useState([]);
  const [selectedContent, setSelectedContent] = useState([]);
  const [prescriptionDate, setPrescriptionDate] = useState(dayjs());
  const [openModal, setOpenModal] = useState(false);

  const { paramsName } = useParams();
  const user_num = paramsName;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const userResponse = await fetch('https://ser.eyas-focus.o-r.kr/api/patient/detialPatient', {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json'
        //   },
        //   body: JSON.stringify({
        //     matching,
        //     user_num
        //   }),
        // });
        // const userData = await userResponse.json();
        // if (userData.status) {
        //   setDetailUser(userData.data)
        //   console.log(userData.data)
        // };

        const { data: contentData } = await api.post('/manager/content/contentList');
        const payload = contentData?.data || contentData;
        if (payload?.status) {
          setContentList(Array.isArray(payload.data) ? payload.data : []);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
        alert('서버 오류가 발생했습니다.');
      }
    };
    fetchData();
  }, [user_num]);

  const insertPrescription = async () => {
    try {
      const { data: result } = await api.post('/manager/content/prescription', {
        selectedContent: selectedContent,
        prescriptionDateYear: prescriptionDate.year(),
        prescriptionDateMon: prescriptionDate.month() + 1,
        prescriptionDateDay: prescriptionDate.date(),
        user_num,
      });
      const payload = result?.data || result;
      if (payload?.status) navigate('/');
      else alert('처방 등록에 실패했습니다.');
    } catch (err) {
      console.error('Error:', err);
      alert('서버 오류가 발생했습니다.');
    }
  };

  return (
    <Menu>
      <Box sx={{
        float: 'left',
        width: 'calc(100% - 260px)',
        minWidth: '98%',
        height: '85vh',
        // height: "auto", // ✅ 자동 높이 조정
        // minHeight: "600px", // ✅ 최소 높이 추가
        marginTop: '30px',
        marginLeft: '10px',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        padding: '10px 2px',
      }}>
        <Typography variant="h4">처방</Typography>
        <Box sx={{ display: 'flex', gap: 4, mt: 2 }}>
          <Typography variant="h5">{user_num}</Typography>
          {/* <Typography variant="h5">{detailUser[0]?.PM_patientSex}</Typography>
          <Typography variant="h5">{detailUser[0]?.PM_patientBirth}</Typography> */}
        </Box>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box
            sx={{
              width: "100%",
              // minHeight: "400px",
              height: "100%",
              // display: "flex",
              // flexDirection: "column",
              // alignItems: "center",
              // justifyContent: "center",
              overflow: "visible", // ✅ 스크롤 방지
            }}
          >
            <Typography variant="h3" sx={{ mt: 2 }}>
              선택한 날짜: {prescriptionDate ? prescriptionDate.format("YYYY-MM-DD") : "날짜를 선택하세요"}
            </Typography>
            <DateCalendar
              value={prescriptionDate}
              onChange={(newValue) => setPrescriptionDate(newValue || dayjs())}
              sx={{
                marginTop: "10px",
                width: "100%",
                height: "700px",
                maxHeight: "700px",

                [`& .MuiDateCalendar-root`]: {
                  width: "100%",
                  height: "100%",
                },

                [`& .MuiPickersDay-root`]: {
                  fontSize: "2rem", // ✅ 날짜 글자 크기 키움
                  width: "100%", // ✅ 날짜 칸 크기 키움
                  height: "100%",
                },

                [`& .MuiDayCalendar-weekContainer`]: {
                  // gap: "16px", // ✅ 주(Week) 간 간격 조정 (더 넓게)
                  height: "60px",
                  marginBottom: "10px"
                },

                [`& .MuiDayCalendar-slideTransition`]: {
                  height: "100%", // ✅ 날짜 부분 높이 키우기
                  minHeight: "500px",
                },

                [`& .MuiTypography-root`]: {
                  fontSize: "2.5rem", // ✅ 월/연도 글씨 크기 키움
                  width: "100%", // ✅ 날짜 칸 크기 키움
                  height: "100%",

                },

                [`& .MuiPickersCalendarHeader-root`]: {
                  marginBottom: "20px",
                },

                [`& .MuiPickersCalendarHeader-label`]: {
                  fontSize: "large",
                },

              }}

            />
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 3 }}
              onClick={() => setOpenModal(true)}
            >
              확인
            </Button>
          </Box>
        </LocalizationProvider>
      </Box>

      {/* 리스트 모달 */}
      <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="md" fullWidth>
        <DialogTitle>콘텐츠 선택</DialogTitle>
        <DialogContent>
          <List sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 2 }}>
            {contentList.map((item, index) => (
              <ListItemButton
                key={index}
                sx={{
                  border: '1px solid #ddd',
                  borderRadius: 2,
                  boxShadow: selectedContent.includes(index) ? '0px 4px 10px rgba(0, 0, 0, 0.2)' : 'none',
                  backgroundColor: selectedContent.includes(index) ? '#f0f8ff' : 'transparent',
                }}
                onClick={() =>
                  setSelectedContent((prev) =>
                    prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
                  )
                }
              >
                <ListItemAvatar>
                  <Avatar src={image} alt={item.url} sx={{ width: 100, height: 100 }} />
                </ListItemAvatar>
                <ListItemText primary={item.content_name} sx={{ textAlign: 'center' }} />
              </ListItemButton>
            ))}
          </List>
          <Button variant="contained" color="primary" sx={{ mt: 3, float: 'right' }} onClick={insertPrescription}>
            처방하기
          </Button>
        </DialogContent>
      </Dialog>
    </Menu>
  );
}

export default Detailprescription;
